import { Info, Sparkles } from 'lucide-react'
import { useId, useState } from 'react'

const cx = (...parts) => parts.filter(Boolean).join(' ')

function AiHintBadge({ label, description, className = '', generated = false }) {
  const [open, setOpen] = useState(false)
  const hintId = useId()

  return (
    <span className={cx('relative inline-flex', className)}>
      <button
        type="button"
        aria-expanded={open}
        aria-describedby={open ? hintId : undefined}
        onClick={() => setOpen((value) => !value)}
        className="inline-flex items-center gap-1 rounded-full border border-indigo-200 bg-indigo-50 px-2 py-0.5 text-[10px] font-semibold text-indigo-800 transition-colors hover:bg-indigo-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500/40"
      >
        {generated ? <Info className="h-3 w-3" aria-hidden="true" /> : <Sparkles className="h-3 w-3" aria-hidden="true" />}
        {label}
      </button>
      {open ? (
        <span
          id={hintId}
          role="tooltip"
          className="absolute left-0 top-full z-50 mt-1 w-64 rounded-md border border-slate-200 bg-white px-3 py-2 text-left text-xs font-normal leading-5 text-slate-700 shadow-lg"
        >
          {description}
        </span>
      ) : null}
    </span>
  )
}

export function AiFeatureBadge({ className = '' }) {
  return (
    <AiHintBadge
      label="AI 기능"
      description="이 기능은 생성형 AI를 활용합니다. 결과를 적용하거나 발송하기 전에 사실관계와 표현을 확인해 주세요."
      className={className}
    />
  )
}

export function AiDisclosure({ className = '' }) {
  return <AiFeatureBadge className={className} />
}

export function AiGeneratedBadge({ className = '' }) {
  return (
    <AiHintBadge
      label="[AI]"
      description="생성형 AI가 만든 결과입니다. 적용하거나 발송하기 전에 사실관계와 표현을 확인해 주세요."
      className={className}
      generated
    />
  )
}

export function AiGeneratedNotice({ className = '' }) {
  return <AiGeneratedBadge className={className} />
}